import React from "react";

export default function CounterpartyPlatformsForm(props) {
    const renderPlaform = (item, i) => (
        <div key={i} className="col-form-label col-form-label-sm">
            <a href={item.url} target="_blank" rel="noopener noreferrer">
                {item.name}
            </a>
        </div>
    );

    return (
        <div className="row form-group">
            <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                Условия работы
            </label>
            <div className="col-sm-8 col-md-9">
                {props.platforms.map(renderPlaform)}
                {props.children}
            </div>
        </div>
    );
}
